import React, { CSSProperties } from "react";
import Icon from "src/components/icon";

type DropdownProps = {
    placeholder: string;
    value?: string;
    onKeyDown?: (ev: React.KeyboardEvent<HTMLDivElement>) => void;
    onClick?: (ev: React.MouseEvent<HTMLDivElement>) => void;
    className?: string;
    inputColor?: string;
    backgroundColor?: string;
    borderColor?: string;
};

export default class Dropdown extends React.Component<DropdownProps> {
    get style(){
        return {
            '--input-background-color': this.props.backgroundColor,
            '--input-border-color': this.props.borderColor,
            '--input-text-color': this.props.inputColor
        } as CSSProperties
    }
    render(): React.ReactNode {
        return (
        <div
            role="button"
            aria-label={this.props.placeholder}
            tabIndex={0}
            onKeyDown={this.props.onKeyDown}
            onClick={this.props.onClick}
            style={this.style}
            className={`w-full max-w-[322px] h-10 px-4 py-3 bg-[color:var(--input-background-color)] rounded-lg border border-[color:var(--input-border-color)] justify-start items-center gap-2.5 inline-flex focus:outline-none focus:ring-1 focus:ring focus:ring-blue-600 ${this.props.className || ""}`}>
            <div className="grow shrink basis-0 justify-between items-center flex overflow-hidden">
                {this.props.value
                ? <div className="caption text-[color:var(--input-text-color)] text-ellipsis overflow-hidden whitespace-nowrap">{this.props.value}</div>
                : <div className="caption text-[color:var(--input-placeholder-color)]">{this.props.placeholder}</div> }
                <Icon icon="ChevronDown" className="w-4 h-4 min-w-[1rem] min-h-[1rem] text-[color:var(--input-chevron-color)]" />
            </div>
        </div>
        );
    }
}